import React from 'react'
import { tableData } from '../../data/tableData'
import { InformationCircleIcon } from 'hugeicons-react';

function SinglePageTable({measuresTableData}) {



  return (
    <>
    <div className="table">
                
        <table>
            <thead>
                <tr>
                    <th>Measures Name</th>
                    <th className='bm'>Goal</th>
                    <th>01</th>
                    <th>02</th>
                    <th>03</th>
                    <th>04</th>
                    <th>05</th>
                    <th>06</th>
                    <th>07</th>
                    <th>08</th>
                    <th>09</th>
                    <th>10</th>
                    <th>11</th>
                    <th>12</th>
                </tr>
            </thead>
            
            <tbody>
    {
        measuresTableData && Object.keys(measuresTableData).length > 0 && (
            <>
                {["CENSUS - VOLUME & UTILIZATION", "CLINICAL QUALITY", "HUMAN RESOURCES"].map((category) => {
                    const measuresInCategory = Object.keys(measuresTableData).filter(measure => 
                        measuresTableData[measure].category === category // Assuming your data has a 'category' field
                    );

                    return (
                        <React.Fragment key={category}>
                            <tr>
                                <td colSpan={14} style={{ fontWeight: 'bold' }}>{category}</td>
                            </tr>
                            {measuresInCategory.map((measureData, index) => (
                                <tr key={index}>
                                    

          <td className="hover-container" 
          
          >
          {measureData}
          <div className="hover-info">
          <InformationCircleIcon color="#CCCCCC"/>

          <div className="hover-description">
          {measuresTableData[measureData].measure_description} 
            </div>
          </div>
          </td>
                                    <td className='bm'>{measuresTableData[measureData].BM !== null? measuresTableData[measureData].BM: "-"}
                                    {measuresTableData[measureData].measure_unit === "Percentage" && (measuresTableData[measureData].BM || measuresTableData[measureData].BM == 0)? "%": ""}
                                    </td>
                                    {[...Array(12)].map((_, monthIndex) => {
                                        const value = measuresTableData[measureData]["months"][monthIndex + 1];
                                        const isMissing = value == null || value === 0;
                                        return (
                                            <td key={monthIndex + 1}
                                            className={
                                                (measuresTableData[measureData].BM === null || isMissing) ? "" :
                                                value < measuresTableData[measureData].BM
                                                  ? "green-bg"
                                                  : value > measuresTableData[measureData].BM
                                                  ? "red-bg"
                                                  : "yellow-bg"
                                            }
                                            >
                                                {isMissing ? "-" : value}
                                                {measuresTableData[measureData].measure_unit === "Percentage" && !isMissing ? "%" : ""}
                                            </td>
                                        );
                                    })}
                                </tr>
                            ))}
                        </React.Fragment>
                    );
                })}
            </>
        )
    }
</tbody>

        </table>
    </div>
    </>
  )
}

export default SinglePageTable